import { apiSlice } from '../../api-slice';

export const rolePermissionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createRolePermissions: builder.mutation({
      query: (data) => ({
        url: 'roles',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Roles_Permissions'],
    }),

    getRolePermission: builder.query({
      query: () => `roles?fields=permissions`,
      providesTags: ['Roles_Permissions'],
      keepUnusedDataFor: 600,
    }),

    getRole: builder.query({
      query: () => `roles`,
      providesTags: ['Roles'],
      keepUnusedDataFor: 600,
    }),

    // New updateRole mutation
    updateRole: builder.mutation({
      query: ({ id, data }) => ({
        url: `roles/${id}`,
        method: 'PUT', // Use PATCH if your API partially updates data
        body: data,
      }),
      invalidatesTags: ['Roles', 'Roles_Permissions', 'Auth_User'],
    }),
  }),
});

export const {
  useGetRolePermissionQuery,
  useCreateRolePermissionsMutation,
  useGetRoleQuery,
  useUpdateRoleMutation,
} = rolePermissionApi;
